// Navbar.js
import React from 'react';

const Navbar = () => {
    return (
        <nav>
            <div className='inner'>
                <a href='/'><h3>GreenPlates</h3></a>
            </div>
        </nav>
    );
};

export default Navbar;
